import type { FaireProductEntity } from "../../entity_types/product";

export const p_tb3exxtw3u: FaireProductEntity = {
  token: "p_tb3exxtw3u",
  type: "product",
  name: "Card Box Bible Story Memory Games New Testament",
  brandToken: "b_3811aa80",
  brandName: "Christian Art Gifts",
  imageUrl:
    "https://cdn.faire.com/fastly/9a5e6f3b5183816aa97e9f18548355c2e6f68f5b61b9f8232daf45283508b03e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a9065d73f49146b388fb5fa2283761b6f43ef280f180972730034d94fa98ba31.jpeg",
    "https://cdn.faire.com/fastly/991956e56cbd5c6f0661e2283181e5ddec4b0c8bd481243370ea8a2a2a140334.jpeg",
    "https://cdn.faire.com/fastly/d64cc0772bf62016bcc64fdc95a8980f688d58e44794bc8241cdb821c552f397.jpeg",
  ],
  priceDollars: 6.93,
  description:
    'The New Testament Bible Story Memory Games Boxed Set is a fun and interactive way to learn about some of the amazing events of Jesus\' life as told in the New Testament.\nCartoon illustration on cover,  \nSturdy lidded box,  \nSuitable for ages 5-8,  \n59 full-color cards,  \n4 double-sided clue cards,  \nTwo suggested games: matching and memory,  \nIntended for 2-6 players,  \nCard size: 4.5" x 3.25" (114 x 83mm),  \nBox size: 4.7" x 3.6" x 1.2" (119 x 91 x 30mm)',
  tags: [],
  msrpDollars: 13.84,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:10.488Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
